export default __webpack_public_path__ + "static/mopawi-7417e1fa902cf8c734a224210a044e34.webp";